import type { AppContentCurrentEntity } from '../../domain/entities/app-content.entity';
import {
  LEGAL_DOCUMENT_DEFAULT_PRIVACY,
  LEGAL_DOCUMENT_DEFAULT_TERMS,
  LEGAL_DOCUMENT_DEFAULT_VERSION_NUMBER,
} from '@/core/presentation/constants/legal-document-default-content';

export function publishedTermsContent(current: AppContentCurrentEntity | null): string {
  const t = current?.currentContent?.trim();
  return t ? t : LEGAL_DOCUMENT_DEFAULT_TERMS;
}

export function publishedPrivacyContent(current: AppContentCurrentEntity | null): string {
  const t = current?.currentContent?.trim();
  return t ? t : LEGAL_DOCUMENT_DEFAULT_PRIVACY;
}

export function publishedDocumentVersion(current: AppContentCurrentEntity | null): number {
  const v = current?.currentVersion;
  if (typeof v === 'number' && Number.isInteger(v) && v > 0) {
    return v;
  }
  return LEGAL_DOCUMENT_DEFAULT_VERSION_NUMBER;
}
